jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

AOS.init();

var resizedTimes = 0;
function resizeIframe(height, id) {
  var new_height = parseInt(height);
  $("#" + id).css("height", new_height);
}

$(".burger-container").on("click", function () {
  $(".header-nav").addClass("menu-open");
  $("body").addClass("overflow");
});

$(".mobile-close").on("click", function () {
  $(".header-nav").removeClass("menu-open");
  $("body").removeClass("overflow");
  $(".level2-slide").removeClass("open");
});

$("li.level1.sublevels .show-more").on("click", function () {
  $(this).closest("li.level1").children(".level2-slide").toggleClass("open");
});

$(".side-navi-title").on("click", function () {
  $(this).closest(".level2-slide").removeClass("open");
});

$("#newsletter-subscribe-default").on("submit", function () {
  var fbqData = {
    content_category: "Newsletter",
    content_name: $(this).find(".emailInput").val(),
  };
  fbq("track", "Lead", fbqData);
});

$("#newsletter-subscribe-footer").on("submit", function () {
  var fbqData = {
    content_category: "Newsletter",
    content_name: $(this).find(".emailInput").val(),
  };
  fbq("track", "Lead", fbqData);
});

$("#user-menu").on("click", function (event) {
  event.stopPropagation();
  $(".dropdown-menu").toggleClass("open");
});

$(document).on("click", function (event) {
  if (!$(event.target).closest(".dropdown-menu, #user-menu").length) {
    $(".dropdown-menu").removeClass("open");
  }
});

$(".open-search").on("click", function () {
  $(".header-search").fadeToggle(300);
});
